import {
  dbReducer,
  ReduxRemove,
  ReduxChange,
  ReduxFindAll,
  ReduxUpdate,
  ReduxInsert,
  ReduxFind,
} from '@weblite/persist'
import { IMessage, Message } from '@weblite/ts-action/message'
import { isEditMessagePatch } from '$logic/message'

const COLLECTION = 'openedRoomMessages'

export const openedRoomMessagesStorage = {
  deleteAll() {
    ReduxRemove(COLLECTION, {})
  },

  getAll(): Message[] {
    return ReduxFindAll(COLLECTION)
  },

  get(iid: number): Message {
    return ReduxFind(COLLECTION, { iid })[0]
  },

  editMessage(
    iid: number,
    patch: Pick<IMessage, 'body' | 'attachment' | 'pinned'>,
  ) {
    ReduxUpdate(
      COLLECTION,
      { iid, 'patches.deleted': { $exists: false } },
      {
        $set: {
          ...patch,
          ...(isEditMessagePatch(patch) && { patches: { edited: true } }),
        },
      },
    )
  },

  editViewCount(iid: number, viewCount: number) {
    ReduxUpdate(
      COLLECTION,
      { iid, 'patches.deleted': { $exists: false } },
      { $set: { viewCount } },
    )
  },

  deleteMessages(iids: number[]) {
    ReduxUpdate(
      COLLECTION,
      { iid: { $in: iids } },
      { $set: { body: null, patches: { deleted: true } } },
    )
  },

  replace(messages: Message[]) {
    ReduxChange(COLLECTION, messages)
  },

  insert(messages: Message[]) {
    ReduxInsert(COLLECTION, messages)
  },
}

export const openedRoomMessagesReducer = dbReducer(['main', COLLECTION])
